import { connectAPI } from "./api"

export const getContent = (): Promise<Tutorial.Content> => {
    const match = window.location.pathname.match(
        /\/((dashboard|workspace).*?)\/tutorial/,
    )
    if (match) {
        const urlpart = match[1]
        return connectAPI.getJSON("tutorial/contentfor" + urlpart)
    } else {
        throw new Error("Invalid URL")
    }
}
